import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { selectDrawerStatus } from '../../../redux/selectors'
import { fetchVaStatsReports } from '../../../redux/actions'
import { formatDate, formatDateTime, formatTime } from '../../../formatting'
import Header from '../../Header'
import VaGraph from './VaGraph'
import { reactPlugin } from '../../../applicationInsights'

export function VaStatsReport() {
  const dispatch = useDispatch()

  const drawerIsOpen = useSelector(selectDrawerStatus)

  const getVaStatsReports = () => dispatch(fetchVaStatsReports())

  const formatTimestampLabels = (lines, reportId) => {
    switch (reportId) {
      case 'va30':
        return lines.map((l) => formatDate(l.timestamp))
      case 'vaDay':
        return lines.map((l) => formatDateTime(l.timestamp))
      case 'vaHour':
        return lines.map((l) => formatTime(l.timestamp))
      default:
        return 'todo: format new line type'
    }
  }

  useEffect(() => {
    getVaStatsReports()
  }, [])

  return (
    <div>
      <Header title="VA Status" />
      <VaGraph formatTimestampLabels={formatTimestampLabels} reportId="vaHour" title="Last hour" drawerIsOpen={drawerIsOpen} />
      <VaGraph formatTimestampLabels={formatTimestampLabels} reportId="vaDay" title="Today" drawerIsOpen={drawerIsOpen} />
      <VaGraph formatTimestampLabels={formatTimestampLabels} reportId="va30" title="Last 30 days" drawerIsOpen={drawerIsOpen} />
    </div>
  )
}

export default withAITracking(reactPlugin, VaStatsReport)
